var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_3330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 0H4.00012C1.80037 0 0.000213623 1.80015 0.000213623 3.9999V12.0001C0.000213623 14.1993 1.80037 16 4.00012 16H11.9999C14.1997 16 15.9998 14.1993 15.9998 12.0001V3.9999C15.9998 1.80015 14.1997 0 11.9999 0ZM14.6665 12.0001C14.6665 13.4701 13.4707 14.6666 11.9999 14.6666H4.00012C2.52996 14.6666 1.33358 13.4701 1.33358 12.0001V3.9999C1.33358 2.52955 2.52996 1.33337 4.00012 1.33337H11.9999C13.4707 1.33337 14.6665 2.52955 14.6665 3.9999V12.0001Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3339 4.66646C12.8861 4.66646 13.3338 4.21875 13.3338 3.66648C13.3338 3.11421 12.8861 2.6665 12.3339 2.6665C11.7816 2.6665 11.3339 3.11421 11.3339 3.66648C11.3339 4.21875 11.7816 4.66646 12.3339 4.66646Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 3.99988C5.79044 3.99988 4.00009 5.79042 4.00009 7.99978C4.00009 10.2083 5.79044 12.0001 7.99999 12.0001C10.2089 12.0001 11.9999 10.2083 11.9999 7.99978C11.9999 5.79042 10.2089 3.99988 7.99999 3.99988ZM7.99999 10.6667C6.52741 10.6667 5.33346 9.47275 5.33346 7.99978C5.33346 6.52681 6.52741 5.33324 7.99999 5.33324C9.47258 5.33324 10.6665 6.52681 10.6665 7.99978C10.6665 9.47275 9.47258 10.6667 7.99999 10.6667Z",
    fill: "#272727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_3330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.efabea41eff365b555212eebe060c163.svg";
export { ForwardRef as ReactComponent };